<template>
    <div class="der_rootPanel" ref="der_rootPanelRef" @click="panelClickHandler($event)">
        <div class="der_dialogBody">
            <!-- 背景 -->
            <svg v-if="isShow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="869.020263671875" height="303.0001220703125" viewBox="0 0 869.020263671875 303.0001220703125"
                fill="none" preserveAspectRatio="none">
                <path
                    d="M861.973 267.361L862.999 38.1025L842.051 19L28.9475 19L8 42.2909L8 284.086L20.996 302L204.479 300.5L219.185 287.001L827.516 287.001L827.516 290.057L842.051 290.057L861.973 267.361Z"
                    fill="#03111C" fill-opacity="0">
                </path>
                <path
                    d="M845.651 13.9872L865.746 36.2496L865.746 36.5664L866.516 36.5664L866.516 267.427L842.697 295.766L784.274 295.766L784.145 295.594L239.455 295.594L239.648 295.766L233.292 300L842.505 300L868.442 269.875C868.828 269.472 869.02 268.32 869.02 268.32L869.02 35.5008L848.283 12.4896L229.504 12.0576L227 14.3616L845.651 13.9872Z"
                    fill="#56FEFE">
                </path>
                <path d="M171.409 16.5402L174.637 11.6267L170.622 11.6267L167.395 16.5402L171.409 16.5402Z"
                    fill="url(#linear_fill_96DADDB6-F729-4C03-8794-6F238E314F33)">
                </path>
                <g mask="url(#mask-6673A754-0FF8-4CC4-91A1-CBD8AB203101)">
                    <path d="M171.409 16.5402L174.637 11.6267L170.622 11.6267L167.395 16.5402L171.409 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M165.983 16.5402L169.21 11.6267L165.196 11.6267L161.968 16.5402L165.983 16.5402Z"
                    fill="url(#linear_fill_4878C3F3-8529-4E13-AE9E-690389748C4F)">
                </path>
                <g mask="url(#mask-938208EF-4B2D-4EB8-ADE0-7E2DBD4481CD)">
                    <path d="M165.983 16.5402L169.21 11.6267L165.196 11.6267L161.968 16.5402L165.983 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M160.556 16.5402L163.784 11.6267L159.749 11.6267L156.542 16.5402L160.556 16.5402Z"
                    fill="url(#linear_fill_E981FBB1-D382-4029-9A6D-17F244EFF059)">
                </path>
                <g mask="url(#mask-AC9FA9EF-6123-4672-ACA8-4CBBA7B8AD19)">
                    <path d="M160.556 16.5402L163.784 11.6267L159.749 11.6267L156.542 16.5402L160.556 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M187.991 16.5402L191.219 11.6267L187.184 11.6267L183.957 16.5402L187.991 16.5402Z"
                    fill="url(#linear_fill_2F51AE57-2DCF-4E09-AA5B-B891200399A9)">
                </path>
                <g mask="url(#mask-213C91FC-52C4-4AD8-A44A-76BD03A499CD)">
                    <path d="M187.991 16.5402L191.219 11.6267L187.184 11.6267L183.957 16.5402L187.991 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M210.524 16.5402L213.732 11.6267L209.718 11.6267L206.49 16.5402L210.524 16.5402Z"
                    fill="url(#linear_fill_143ED65E-FA2B-4444-9FCE-F513B7B25257)">
                </path>
                <g mask="url(#mask-F36CF457-12C6-46D4-8A54-1767857C31C9)">
                    <path d="M210.524 16.5402L213.732 11.6267L209.718 11.6267L206.49 16.5402L210.524 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M216.657 16.5402L219.885 11.6267L215.87 11.6267L212.643 16.5402L216.657 16.5402Z"
                    fill="url(#linear_fill_84D6C593-02F8-467D-9CC8-7A3DE9D41536)">
                </path>
                <g mask="url(#mask-D1597F95-E0E4-44B5-8138-4ABE455029A2)">
                    <path d="M216.657 16.5402L219.885 11.6267L215.87 11.6267L212.643 16.5402L216.657 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M222.81 16.5402L226.037 11.6267L222.002 11.6267L218.775 16.5402L222.81 16.5402Z"
                    fill="url(#linear_fill_56F20C8B-F1E6-4FD3-A709-375503D9148E)">
                </path>
                <g mask="url(#mask-D1A43CC8-7C29-40B5-B76D-92977803A8C4)">
                    <path d="M222.81 16.5402L226.037 11.6267L222.002 11.6267L218.775 16.5402L222.81 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M182.565 16.5402L185.793 11.6267L181.758 11.6267L178.53 16.5402L182.565 16.5402Z"
                    fill="url(#linear_fill_1D1EAA15-E59D-4AAA-9376-072BB74F041C)">
                </path>
                <g mask="url(#mask-A9927328-2C26-475F-B3F7-71BE27D16DA7)">
                    <path d="M182.565 16.5402L185.793 11.6267L181.758 11.6267L178.53 16.5402L182.565 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M177.138 16.5402L180.346 11.6267L176.331 11.6267L173.104 16.5402L177.138 16.5402Z"
                    fill="url(#linear_fill_8D474B0F-66E9-47D4-A800-BFFD652123A9)">
                </path>
                <g mask="url(#mask-7D112B6B-6752-4767-8A85-70881B1C6CD0)">
                    <path d="M177.138 16.5402L180.346 11.6267L176.331 11.6267L173.104 16.5402L177.138 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M204.634 16.5402L207.862 11.6267L203.847 11.6267L200.62 16.5402L204.634 16.5402Z"
                    fill="url(#linear_fill_81D2AB43-80F6-4A91-B684-37BF4008802F)">
                </path>
                <g mask="url(#mask-AD5EC6D5-352A-46A2-A27C-ED34CB21BE61)">
                    <path d="M204.634 16.5402L207.862 11.6267L203.847 11.6267L200.62 16.5402L204.634 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M199.207 16.5402L202.435 11.6267L198.421 11.6267L195.193 16.5402L199.207 16.5402Z"
                    fill="url(#linear_fill_28B3AC22-CD9E-40D0-B007-1DCB24708C17)">
                </path>
                <g mask="url(#mask-1C66415B-FEE6-4FBA-9AA3-DDBB00B2F5F1)">
                    <path d="M199.207 16.5402L202.435 11.6267L198.421 11.6267L195.193 16.5402L199.207 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M193.781 16.5402L197.009 11.6267L192.974 11.6267L189.767 16.5402L193.781 16.5402Z"
                    fill="url(#linear_fill_FD52FCA5-B77E-474D-8719-EB4531882505)">
                </path>
                <g mask="url(#mask-A98CFB82-6FAC-47C0-9DF4-58A9F33B0918)">
                    <path d="M193.781 16.5402L197.009 11.6267L192.974 11.6267L189.767 16.5402L193.781 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M155.13 16.5402L158.357 11.6267L154.323 11.6267L151.115 16.5402L155.13 16.5402Z"
                    fill="url(#linear_fill_07087109-A416-4B71-B8A3-83C7A3C4BB93)">
                </path>
                <g mask="url(#mask-D456E77E-163E-4D56-AF6B-5C0A5DE556BB)">
                    <path d="M155.13 16.5402L158.357 11.6267L154.323 11.6267L151.115 16.5402L155.13 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M149.703 16.5402L152.931 11.6267L148.896 11.6267L145.668 16.5402L149.703 16.5402Z"
                    fill="url(#linear_fill_217E012C-3092-4A6C-9E2A-63F7C0DA6871)">
                </path>
                <g mask="url(#mask-0E5DA530-51DA-4490-916F-36F47650D5F7)">
                    <path d="M149.703 16.5402L152.931 11.6267L148.896 11.6267L145.668 16.5402L149.703 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path d="M144.277 16.5402L147.504 11.6267L143.469 11.6267L140.242 16.5402L144.277 16.5402Z"
                    fill="url(#linear_fill_1EF7DA6D-2F98-4D6A-B6BB-94A5BAE1FAD0)">
                </path>
                <g mask="url(#mask-5F5F8322-F257-4268-A101-AD7115FB3E53)">
                    <path d="M144.277 16.5402L147.504 11.6267L143.469 11.6267L140.242 16.5402L144.277 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <g mask="url(#mask-5F5F8322-F257-4268-A101-AD7115FB3E53)">
                    <path d="M138.85 16.5402L142.058 11.6267L138.043 11.6267L134.815 16.5402L138.85 16.5402Z"
                        fill="url(#linear_fill_E1DCE238-CB50-434A-8325-D1BAF794A029)">
                    </path>
                </g>
                <g mask="url(#mask-5F5F8322-F257-4268-A101-AD7115FB3E53)">
                    <path d="M138.85 16.5402L142.058 11.6267L138.043 11.6267L134.815 16.5402L138.85 16.5402Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path
                    d="M221.458 287.545C221.458 286.293 220.429 285.3 219.178 285.3C217.907 285.3 216.899 286.293 216.899 287.545C216.899 288.796 217.907 289.789 219.178 289.789C220.429 289.789 221.458 288.776 221.458 287.545Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M834.559 273.686C834.559 272.455 833.531 271.442 832.28 271.442C831.009 271.442 830 272.455 830 273.686C829.98 274.938 831.009 275.931 832.28 275.931C833.531 275.931 834.559 274.938 834.559 273.686Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M220.651 287.704L819.824 286.242L831.079 275.177C831.079 275.177 831.997 274.77 831.997 274.283L832.364 273.947L832.364 272.973L831.752 273.58C831.569 273.414 831.079 273.31 831.079 273.31C831.079 273.31 830.101 273.727 830.101 274.244C830.101 274.498 830.223 274.726 830.406 274.894L819.518 285.467L220.651 286.929L220.651 287.704Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M205.38 300.895L127.594 300.895L127.594 300.139L205.118 300.139L217.948 287.646L217.948 288.62L205.38 300.895Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M128.401 300.756C128.401 299.524 127.372 298.511 126.121 298.511C124.85 298.511 123.842 299.524 123.842 300.756C123.842 301.987 124.85 303 126.121 303C127.372 303 128.401 301.987 128.401 300.756Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M127.07 300.756C127.07 300.239 126.646 299.822 126.121 299.822C125.597 299.822 125.173 300.239 125.173 300.756C125.173 301.272 125.597 301.689 126.121 301.689C126.646 301.689 127.07 301.272 127.07 300.756Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M127.34 287.229L127.34 283.176L140.594 283.176L143.034 287.229L127.34 287.229ZM141.945 286.566L127.905 286.566L127.905 283.864L140.311 283.864L141.945 286.566Z"
                    fill-rule="evenodd" fill="#56FEFE">
                </path>
                <path d="M126.311 283.176L126.311 287.229L110.899 287.229L110.899 283.176L126.311 283.176Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M94.418 287.229L94.418 283.176L109.83 283.176L109.83 287.229L94.418 287.229ZM109.286 286.566L94.982 286.566L94.982 283.864L109.286 283.864L109.286 286.566Z"
                    fill-rule="evenodd" fill="#56FEFE">
                </path>
                <path d="M93.3486 283.176L93.3486 287.229L77.9365 287.229L77.9365 283.176L93.3486 283.176Z"
                    fill="#56FEFE">
                </path>
                <path d="M76.8877 283.176L76.8877 287.229L61.4756 287.229L61.4756 283.176L76.8877 283.176Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M38.8213 287.229L38.8213 283.176L60.4063 283.176L60.4063 287.229L38.8213 287.229ZM59.8408 286.566L39.3652 286.566L39.3652 283.864L59.8408 283.864L59.8408 286.566Z"
                    fill-rule="evenodd" fill="#56FEFE">
                </path>
                <path
                    d="M117.984 300.965L23.2484 300.965L3.2718 278.19L3.2718 277.836L1.8753 41.3645L26.1478 10.8615L84.2555 10.8615L126.855 11.068L133 8L26.4005 8L0.5453 38.857C0.1995 39.27 0 40.45 0 40.45L0 278.928L20.6549 302.469L120.804 303L117.984 300.965Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M256.718 7.03687L360.443 7.03687L360.443 7.9709L256.974 7.9709L244.146 23.4234L244.146 22.219L256.718 7.03687Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M359.637 7.20875C359.637 8.75673 360.666 9.98489 361.916 9.98489C363.167 9.98489 364.196 8.73174 364.196 7.20875C364.196 5.68576 363.187 4.43262 361.916 4.43262C360.645 4.43262 359.637 5.68576 359.637 7.20875Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M243.158 21.8755C243.158 23.4235 244.187 24.6516 245.438 24.6516C246.709 24.6516 247.717 23.3985 247.717 21.8755C247.738 20.3525 246.709 19.0994 245.438 19.0994C244.167 19.0994 243.158 20.3525 243.158 21.8755Z"
                    fill="#56FEFE">
                </path>
                <path
                    d="M244.49 21.8756C244.49 22.5144 244.913 23.0303 245.438 23.0303C245.962 23.0303 246.386 22.5144 246.386 21.8756C246.386 21.2369 245.962 20.7209 245.438 20.7209C244.913 20.7209 244.49 21.2369 244.49 21.8756Z"
                    fill="#56FEFE">
                </path>
                <g opacity="0.05">
                    <path d="M317 0L314.647 0L308 8L310.353 8L317 0Z" fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.1">
                    <path d="M322 0L319.771 0L312 10L314.229 10L322 0Z" fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.2">
                    <path d="M327 0L324.768 0L317 10L319.232 10L327 0Z" fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.4">
                    <path d="M332 0L329.771 0L322 10L324.229 10L332 0Z" fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.6">
                    <path d="M336 0L334.005 0.015L327 10L329.009 10L336 0Z" fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.8">
                    <path d="M341 0L338.768 0L331 10L333.232 9.985L341 0Z" fill="#56FEFE">
                    </path>
                </g>
                <path d="M346 0L343.771 0.015L336 10L338.229 10L346 0Z" fill="#56FEFE">
                </path>
                <path
                    d="M18.6087 281.34C12.7442 281.34 8 276.591 8 270.755C8 264.903 12.7591 260.169 18.6087 260.169C24.4732 260.154 29.2174 264.903 29.2174 270.755C29.2174 276.606 24.4583 281.34 18.6087 281.34Z"
                    stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                </path>
                <path
                    d="M18.4922 278.203C14.4473 278.203 11.1724 274.936 11.1724 270.9C11.1724 266.864 14.4473 263.596 18.4922 263.596C22.5372 263.596 25.8121 266.864 25.8121 270.9C25.8121 274.936 22.5372 278.203 18.4922 278.203Z"
                    stroke="rgba(86, 254, 254, 1)" stroke-width="0.5">
                </path>
                <g opacity="0.4">
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="2" d="M18.8301 264L17.8301 260">
                    </path>
                </g>
                <g opacity="0.4">
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="2" d="M22.8301 265L24.8301 262">
                    </path>
                </g>
                <g opacity="0.2">
                    <path
                        d="M22.6658 274.602C21.6731 274.602 20.8623 273.791 20.8623 272.799C20.8623 271.806 21.6656 270.995 22.6658 270.995C23.6584 271.003 24.4692 271.806 24.4692 272.799C24.4692 273.791 23.666 274.602 22.6658 274.602Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.6">
                    <path
                        d="M17.1119 272.857C15.2056 272.857 13.6484 271.304 13.6484 269.401C13.6484 267.499 15.1911 265.946 17.1119 265.946C19.0182 265.946 20.5754 267.499 20.5754 269.401C20.5754 271.304 19.0328 272.857 17.1119 272.857Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <path
                    d="M18.4779 251.036L23.4255 258.049L21.112 258.049L18.4486 254.085L15.5378 258.049L12.9478 258.049L18.4779 251.036Z"
                    fill="#56FEFE">
                </path>
                <g opacity="0.8">
                    <path
                        d="M18.4779 245.78L23.4255 252.793L21.112 252.793L18.4486 248.844L15.5378 252.793L12.9478 252.793L18.4779 245.78Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.7">
                    <path
                        d="M18.4779 240.291L23.4255 247.304L21.112 247.304L18.4486 243.34L15.5378 247.304L12.9478 247.304L18.4779 240.291Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.6">
                    <path
                        d="M18.4779 235.034L23.4255 242.048L21.112 242.048L18.4486 238.099L15.5378 242.048L12.9478 242.048L18.4779 235.034Z"
                        fill="#56FEFE">
                    </path>
                </g>
                <g opacity="0.5">
                    <path
                        d="M18.4779 228.994L23.4255 235.993L21.112 235.993L18.4486 232.043L15.5378 235.993L12.9478 235.993L18.4779 228.994Z"
                        stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                    </path>
                </g>
                <g opacity="0.4">
                    <path
                        d="M18.4779 222.953L23.4255 229.952L21.112 229.952L18.4486 226.003L15.5378 229.952L12.9478 229.952L18.4779 222.953Z"
                        stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                    </path>
                </g>
                <g opacity="0.2">
                    <path
                        d="M18.4779 217L23.4255 223.999L21.112 223.999L18.4486 220.049L15.5378 223.999L12.9478 223.999L18.4779 217Z"
                        stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                    </path>
                </g>
                <g opacity="0.6">
                    <path
                        d="M842.756 19.5003L28.1469 19.7989L8.50196 43.8822L9.26948 252.023L6.2695 252.034L5.5 43.3559L6.99999 43.3504L5.83765 42.4023L26.2722 17.3511L26.7221 16.7995L27.434 16.7992L843.447 16.5L843.447 18L844.588 17.0261L862.629 38.1605L861.488 39.1344L862.988 39.1344L862.988 266.83L862.634 267.249L842.713 290.858L842.263 291.391L841.566 291.391L242.809 291.5L242.809 288.5L840.869 288.391L859.988 265.733L859.988 39.6875L842.756 19.5003Z"
                        fill-rule="evenodd" fill="#56FEFE">
                    </path>
                </g>
                <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M841.256 39L854.631 39">
                </path>
                <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M837.988 34.9956L851.726 34.9956">
                </path>
                <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M835.406 31.8755L848.781 31.8755">
                </path>
                <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M832.562 28.4116L846.3 28.4116">
                </path>
                <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M830 25.2668L843.354 25.2668">
                </path>
                <defs>
                    <linearGradient id="linear_fill_96DADDB6-F729-4C03-8794-6F238E314F33" x1="209.22430419921875"
                        y1="14.0869140625" x2="198.96759033203125" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-6673A754-0FF8-4CC4-91A1-CBD8AB203101" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M171.409 16.5402L174.637 11.6267L170.622 11.6267L167.395 16.5402L171.409 16.5402Z"
                            fill="url(#linear_fill_96DADDB6-F729-4C03-8794-6F238E314F33)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_4878C3F3-8529-4E13-AE9E-690389748C4F" x1="209.23977661132812"
                        y1="14.0869140625" x2="188.1229248046875" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-938208EF-4B2D-4EB8-ADE0-7E2DBD4481CD" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M165.983 16.5402L169.21 11.6267L165.196 11.6267L161.968 16.5402L165.983 16.5402Z"
                            fill="url(#linear_fill_4878C3F3-8529-4E13-AE9E-690389748C4F)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_E981FBB1-D382-4029-9A6D-17F244EFF059" x1="209.25396728515625"
                        y1="14.0869140625" x2="177.2742462158203" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-AC9FA9EF-6123-4672-ACA8-4CBBA7B8AD19" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M160.556 16.5402L163.784 11.6267L159.749 11.6267L156.542 16.5402L160.556 16.5402Z"
                            fill="url(#linear_fill_E981FBB1-D382-4029-9A6D-17F244EFF059)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_2F51AE57-2DCF-4E09-AA5B-B891200399A9" x1="225.79653930664062"
                        y1="14.0869140625" x2="215.51968383789062" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-213C91FC-52C4-4AD8-A44A-76BD03A499CD" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M187.991 16.5402L191.219 11.6267L187.184 11.6267L183.957 16.5402L187.991 16.5402Z"
                            fill="url(#linear_fill_2F51AE57-2DCF-4E09-AA5B-B891200399A9)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_143ED65E-FA2B-4444-9FCE-F513B7B25257" x1="248.33123779296875"
                        y1="14.0869140625" x2="238.06463623046875" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-F36CF457-12C6-46D4-8A54-1767857C31C9" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M210.524 16.5402L213.732 11.6267L209.718 11.6267L206.49 16.5402L210.524 16.5402Z"
                            fill="url(#linear_fill_143ED65E-FA2B-4444-9FCE-F513B7B25257)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_84D6C593-02F8-467D-9CC8-7A3DE9D41536" x1="254.46975708007812"
                        y1="14.0869140625" x2="244.22088623046875" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-D1597F95-E0E4-44B5-8138-4ABE455029A2" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M216.657 16.5402L219.885 11.6267L215.87 11.6267L212.643 16.5402L216.657 16.5402Z"
                            fill="url(#linear_fill_84D6C593-02F8-467D-9CC8-7A3DE9D41536)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_56F20C8B-F1E6-4FD3-A709-375503D9148E" x1="260.6119689941406"
                        y1="14.0869140625" x2="250.3406982421875" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-D1A43CC8-7C29-40B5-B76D-92977803A8C4" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M222.81 16.5402L226.037 11.6267L222.002 11.6267L218.775 16.5402L222.81 16.5402Z"
                            fill="url(#linear_fill_56F20C8B-F1E6-4FD3-A709-375503D9148E)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_1D1EAA15-E59D-4AAA-9376-072BB74F041C" x1="225.81057739257812"
                        y1="14.0869140625" x2="204.67425537109375" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-A9927328-2C26-475F-B3F7-71BE27D16DA7" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M182.565 16.5402L185.793 11.6267L181.758 11.6267L178.53 16.5402L182.565 16.5402Z"
                            fill="url(#linear_fill_1D1EAA15-E59D-4AAA-9376-072BB74F041C)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_8D474B0F-66E9-47D4-A800-BFFD652123A9" x1="225.8272705078125"
                        y1="14.0869140625" x2="193.8268585205078" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-7D112B6B-6752-4767-8A85-70881B1C6CD0" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M177.138 16.5402L180.346 11.6267L176.331 11.6267L173.104 16.5402L177.138 16.5402Z"
                            fill="url(#linear_fill_8D474B0F-66E9-47D4-A800-BFFD652123A9)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_81D2AB43-80F6-4A91-B684-37BF4008802F" x1="242.44781494140625"
                        y1="14.0869140625" x2="232.19235229492188" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-AD5EC6D5-352A-46A2-A27C-ED34CB21BE61" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M204.634 16.5402L207.862 11.6267L203.847 11.6267L200.62 16.5402L204.634 16.5402Z"
                            fill="url(#linear_fill_81D2AB43-80F6-4A91-B684-37BF4008802F)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_28B3AC22-CD9E-40D0-B007-1DCB24708C17" x1="242.46182250976562"
                        y1="14.0869140625" x2="221.34683227539062" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-1C66415B-FEE6-4FBA-9AA3-DDBB00B2F5F1" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M199.207 16.5402L202.435 11.6267L198.421 11.6267L195.193 16.5402L199.207 16.5402Z"
                            fill="url(#linear_fill_28B3AC22-CD9E-40D0-B007-1DCB24708C17)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_FD52FCA5-B77E-474D-8719-EB4531882505" x1="242.48089599609375"
                        y1="14.0869140625" x2="210.501220703125" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-A98CFB82-6FAC-47C0-9DF4-58A9F33B0918" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M193.781 16.5402L197.009 11.6267L192.974 11.6267L189.767 16.5402L193.781 16.5402Z"
                            fill="url(#linear_fill_FD52FCA5-B77E-474D-8719-EB4531882505)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_07087109-A416-4B71-B8A3-83C7A3C4BB93" x1="209.2591552734375"
                        y1="14.0869140625" x2="166.41989135742188" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-D456E77E-163E-4D56-AF6B-5C0A5DE556BB" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M155.13 16.5402L158.357 11.6267L154.323 11.6267L151.115 16.5402L155.13 16.5402Z"
                            fill="url(#linear_fill_07087109-A416-4B71-B8A3-83C7A3C4BB93)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_217E012C-3092-4A6C-9E2A-63F7C0DA6871" x1="209.2247314453125"
                        y1="14.0869140625" x2="155.51377868652344" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-0E5DA530-51DA-4490-916F-36F47650D5F7" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M149.703 16.5402L152.931 11.6267L148.896 11.6267L145.668 16.5402L149.703 16.5402Z"
                            fill="url(#linear_fill_217E012C-3092-4A6C-9E2A-63F7C0DA6871)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_1EF7DA6D-2F98-4D6A-B6BB-94A5BAE1FAD0" x1="209.22445678710938"
                        y1="14.0869140625" x2="144.6598663330078" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                    <mask id="mask-5F5F8322-F257-4268-A101-AD7115FB3E53" style="mask-type:alpha"
                        maskUnits="userSpaceOnUse">
                        <path d="M144.277 16.5402L147.504 11.6267L143.469 11.6267L140.242 16.5402L144.277 16.5402Z"
                            fill="url(#linear_fill_1EF7DA6D-2F98-4D6A-B6BB-94A5BAE1FAD0)">
                        </path>
                    </mask>
                    <linearGradient id="linear_fill_E1DCE238-CB50-434A-8325-D1BAF794A029" x1="209.26678466796875"
                        y1="14.0869140625" x2="135.8214111328125" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                        <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                        <stop offset="1" stop-color="#000000" />
                    </linearGradient>
                </defs>
            </svg>

            <!-- 标题区域 -->
            <div v-if="isShow" class="der_titlePanel">
                <p>{{ dreamDict.get(dreamId) }}</p>
                <!-- 标题装饰 -->
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="809.7092895507812" height="3.5" viewBox="0 0 809.7092895507812 3.5" fill="none"
                    preserveAspectRatio="none">
                    <path
                        d="M762.257 0L763.113 0.854002L764.764 2.5L0 2.5L0 3.5L809.709 3.5L808.853 2.646L806.347 0.145998L806.2 0L762.257 0ZM766.18 2.5L764.676 1L805.787 1L807.291 2.5L766.18 2.5Z"
                        fill-rule="evenodd" fill="url(#linear_fill_79CA141F-7572-4DD6-AEA5-15AE798F30A4)">
                    </path>
                    <defs>
                        <linearGradient id="linear_fill_79CA141F-7572-4DD6-AEA5-15AE798F30A4" x1="306.9585266113281"
                            y1="4.1978759765625" x2="14.521636962890625" y2="4.19775390625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#56FEFE" />
                            <stop offset="1" stop-color="#56FEFE" stop-opacity="0.3" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>

            <!-- 中心区域(地图、左右导航标题)  preserveAspectRatio="none"-->
            <div class="der_corePanel">
                <img v-if="dreamId === 1" src="../assets/dream1.svg" alt="">
                <img v-else-if="dreamId === 2" src="../assets/dream2.svg" alt="">
                <!-- 特殊处理 -->
                <div v-else-if="dreamId === 3" class="der_multiplePanel">
                    <img v-if="littlePageNum === 1" src="../assets/dream3.svg" alt="">
                    <img v-if="littlePageNum === 2" src="../assets/dream31.svg" alt="">
                    <img v-if="littlePageNum === 3" src="../assets/dream32.svg" alt="">
                </div>
                <img v-else-if="dreamId === 4" src="../assets/dream4.svg" alt="">
                <img v-else-if="dreamId === 5" src="../assets/dream5.svg" alt="">
                <img v-else-if="dreamId === 6" src="../assets/dream6.svg" alt="">
                <img v-else-if="dreamId === 7" src="../assets/dream7.svg" alt="">
                <img v-else-if="dreamId === 8" src="../assets/dream8_new.svg" alt="">
            </div>

            <span v-if="dreamId === 3" class="der_goBackBtn" title="上一页" @click="pushToNextPageHandler(false)">
                <i class="el-icon-arrow-left"></i>
            </span>
            <span v-if="dreamId === 3" class="der_goNextBtn" title="下一页" @click="pushToNextPageHandler(true)">
                <i class="el-icon-arrow-right"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "DreamWindow",
    props: ["opening", "dreamId"],
    data() {
        return {
            isShow: true,
            dreamDict: new Map(
                [
                    [1, "\"3+3+6\" 战略布局"],
                    [2, "\"1641\" 工程"],
                    [3, "\"是毋追求\" 发展理念"],
                    [4, "\"六共六合\" 经营理念"],
                    [5, "\"一委四心\" 组织理念"],
                    [6, "\"九四管理\" 施工理念"],
                    [7, "\"一核四全及三力一孔\" 用人理念"],
                    [8, "\"12345\" 项目管理思路"]
                ]
            ),
            // 集团理念三为多页
            littlePageNum: 1,
        }
    },
    watch: {
        opening: {
            handler(newVal) {
                if (this.$refs["der_rootPanelRef"] == null) {
                    return;
                }
                this.$refs["der_rootPanelRef"].style.width = newVal === true ? "100vw" : "0";
                this.$refs["der_rootPanelRef"].style.height = newVal === true ? "100vh" : "0";
                this.$refs["der_rootPanelRef"].style.opacity = newVal === true ? "1" : "0";

                if (newVal) {
                    // 默认复位
                    this.littlePageNum = 1;
                }
            }
        }
    },
    methods: {
        /**
         * 处理鼠标点击旁边关闭窗口
         * @param e
         */
        panelClickHandler(e) {
            try {
                if (e && e.target) {
                    if (e.target.tagName === 'DIV' && e.target.className === 'der_rootPanel') {
                        this.$emit('update:opening', false);
                    }
                }
            } catch (e) {
                console.log(`错误: ${e || e.message}`);
            }
        },
        pushToNextPageHandler(isNext) {
            // 跳转到下一页
            if (isNext) {
                this.littlePageNum = this.littlePageNum + 1 > 3 ? this.littlePageNum : this.littlePageNum + 1;
                return;
            }
            this.littlePageNum = this.littlePageNum - 1 < 1 ? this.littlePageNum : this.littlePageNum - 1;
        }
    }
} 
</script>


<style lang="scss" scoped>
.der_rootPanel {
    transition: all 0.5s;
    position: fixed;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left: 0px;
    width: 0px;
    height: 0px;
    margin: auto;
    backdrop-filter: blur(3px);
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 999999;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;

    >.der_dialogBody {
        width: auto;
        height: auto;
        min-width: 60vw;
        border-radius: 0.4rem;
        position: relative;
        display: flex;
        flex-direction: column;

        // 整体背景图
        >svg {
            position: absolute;
            top: 0px;
            bottom: 0px;
            right: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
        }

        >.der_titlePanel {
            margin-bottom: 1rem;
            margin-top: 2rem;
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            >svg {
                width: 80%;
            }

            >p {
                margin: 0px;
                width: 100%;
                font-weight: 600;
                font-size: 1.3rem;
                height: 2.3rem;
                line-height: 2.3rem;
                // color: #56fefe;
                background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                white-space: nowrap;
                writing-mode: horizontal-tb;
                text-orientation: upright;
                animation: textShadowInOut 1.5s linear infinite alternate;
                -webkit-text-stroke: 2px #2e828c;
                text-shadow: 1px 0 5px #b9f8ff;
            }
        }

        >.der_goBackBtn,
        >.der_goNextBtn {
            position: absolute;
            top: 0px;
            bottom: 0px;
            margin: auto;
            width: 1rem;
            height: 1rem;
            display: flex;
            padding: 0.3rem;
            border-radius: 50%;
            justify-content: center;
            align-items: center;
            color: #56fefe;
            cursor: pointer;
            font-size: 2rem;

            &:hover {
                transition: all 0.3s;
                transform: scale(1.3);
                text-shadow: 0px 0px 0.3rem #56fefe;
                font-weight: bold;
            }
        }

        >.der_goBackBtn {
            left: 1rem;
        }

        >.der_goNextBtn {
            right: 1rem;
        }

        >.der_corePanel {
            flex: 1;
            margin: 0px 3.5rem 2.5rem 3.5rem;
            display: flex;
            flex-direction: row;
            position: relative;
            justify-content: center;
            align-items: center;

            // 集团理念多组的容器
            >.der_multiplePanel {
                position: relative;
            }
        }
    }
}
</style>